/**
 *
 * @param arr1 array containing duplicated items
 * @param arr2 main array to remove from
 * @param key to identify different objects
 * @returns array of merged unique objects
 */
export const mergeWithoutDuplicates = (arr1: object[], arr2: object[], key: string): object[] => {
  const arr1Keys = arr1.map((el: Record<string, any>) => el[key]);
  const arr2WODuplicates: object[] = arr2.filter(
    (obj2: Record<string, any>) => !arr1Keys.some((arr1Key) => obj2[key] === arr1Key),
  );
  return [...arr1, ...arr2WODuplicates];
};
